var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.isLoading)?_c('PreLoader'):_vm._e(),(!_vm.isLoading)?_c('SectorForm',{attrs:{"sector":_vm.sector,"submitName":_vm.$t('add')},on:{"addOrUpdateSector":function($event){return _vm.addOrUpdateSector()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }